import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';//font awesome
import { library } from '@fortawesome/fontawesome-svg-core';//font awesome
import { fas } from '@fortawesome/free-solid-svg-icons';//font awesome
import { far } from '@fortawesome/free-regular-svg-icons';//font awesome
import {DataTablesModule} from 'angular-datatables';
import {ServiciodepedidovigenteService}from './serviciodepedidovigente.service';
import {ServiGetPostsService}from './servi-get-posts.service';
import {ServiMailsService}from './servi-mails.service';
import {ServiEliminaUsuarioService}from './servi-elimina-usuario.service'
import {AuthGuardService}from'./auth-guard-service.service';
import * as firebase from 'firebase';
import { IonicSelectableModule } from 'ionic-selectable';
import { HttpClientModule } from '@angular/common/http'; 
import {ModalseleccionaAfePageModule} from './modalselecciona-afe/modalselecciona-afe.module'
import { ChartsModule } from 'ng2-charts';
import { AngularFireModule } from '@angular/fire'; //se instala de aca: ng add @angular/fire
import {AngularFireFunctionsModule,} from '@angular/fire/functions';
import {ModalTicketsSinTarifaPageModule} from './modal-tickets-sin-tarifa/modal-tickets-sin-tarifa.module'
import {ModalDetallePageModule} from './modal-detalle/modal-detalle.module'

var config = {
  //PRODUCCION:
  apiKey: "AIzaSyBDe4Tdl9GEtrm_9nV73duUinr8RoKwQZY",
  authDomain: "gt-transporte.firebaseapp.com",
  databaseURL: "https://gt-transporte.firebaseio.com",
  projectId: "gt-transporte",
  storageBucket: "gt-transporte.appspot.com",
  messagingSenderId: "393371067681"

  // //DESARROLLO:
    // apiKey: "AIzaSyAnCbqOeK7X-Q0R906Arkh5lGcNuaNJbaU",
    // authDomain: "gt-transporte-dev.firebaseapp.com",
    // databaseURL: "https://gt-transporte-dev.firebaseio.com",
    // projectId: "gt-transporte-dev",
    // storageBucket: "gt-transporte-dev.appspot.com",
    // messagingSenderId: "549347731652",
    // appId: "1:549347731652:web:20921ba5175593ad6e8191"

};

AngularFireModule.initializeApp(config);
firebase.initializeApp(config);





library.add(fas, far);//font awesome

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule, 
    FontAwesomeModule, 
    DataTablesModule, 
    IonicSelectableModule,
    HttpClientModule,
    ModalseleccionaAfePageModule,
    ChartsModule,
    AngularFireModule.initializeApp(config),
    AngularFireFunctionsModule,
    ModalTicketsSinTarifaPageModule,
    ModalDetallePageModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ServiciodepedidovigenteService,AuthGuardService,ServiGetPostsService,ServiMailsService,ServiEliminaUsuarioService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
